
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartUt_457JmBVYx9S24FGjbaOOJXpGsH2KCwq9c6mPVCCSk8Meta } from "/opt/buildhome/repo/src/nuxt/pages/cart.vue?macro=true";
import { default as _91_46_46_46slug_935emrVJNK9Drp9RoVbbV6dBQe6_lPwAkp_45rnQrvI5XqkMeta } from "/opt/buildhome/repo/src/nuxt/pages/[...slug].vue?macro=true";
import { default as searchzxla6POCsnTCgyFv7A1n7OY548SNe9Aa5F591SRTOlMMeta } from "/opt/buildhome/repo/src/nuxt/pages/iframe/search.vue?macro=true";
import { default as menunIOxEhqACJQsPFCiSlJ7EiVmA9PJuxtgzoPya5Bvt9YMeta } from "/opt/buildhome/repo/src/nuxt/pages/components/menu.vue?macro=true";
import { default as _91_46_46_46slug_93EEr3d6vTRvtr7uNf_bpjiZjJh5cWBOldP72iGvWFKDcMeta } from "/opt/buildhome/repo/src/nuxt/pages/iframe/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93Tz8rFahOAo44p2KchSrcLzMSJuNSvwi_45pnkF2MMAAl4Meta } from "/opt/buildhome/repo/src/nuxt/pages/symbol/[...slug].vue?macro=true";
import { default as footerLOoVmusBf3s93__RF8li1ezxpjizmAluOi_45emBpDwKkMeta } from "/opt/buildhome/repo/src/nuxt/pages/components/footer.vue?macro=true";
import { default as component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRIMeta } from "/opt/buildhome/repo/src/nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRI } from "/opt/buildhome/repo/src/nuxt/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/cart.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/[...slug].vue")
  },
  {
    name: "iframe-search",
    path: "/iframe/search",
    meta: searchzxla6POCsnTCgyFv7A1n7OY548SNe9Aa5F591SRTOlMMeta || {},
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/iframe/search.vue")
  },
  {
    name: "components-menu",
    path: "/components/menu",
    meta: menunIOxEhqACJQsPFCiSlJ7EiVmA9PJuxtgzoPya5Bvt9YMeta || {},
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/components/menu.vue")
  },
  {
    name: "iframe-slug",
    path: "/iframe/:slug(.*)*",
    meta: _91_46_46_46slug_93EEr3d6vTRvtr7uNf_bpjiZjJh5cWBOldP72iGvWFKDcMeta || {},
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/iframe/[...slug].vue")
  },
  {
    name: "symbol-slug",
    path: "/symbol/:slug(.*)*",
    meta: _91_46_46_46slug_93Tz8rFahOAo44p2KchSrcLzMSJuNSvwi_45pnkF2MMAAl4Meta || {},
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/symbol/[...slug].vue")
  },
  {
    name: "components-footer",
    path: "/components/footer",
    meta: footerLOoVmusBf3s93__RF8li1ezxpjizmAluOi_45emBpDwKkMeta || {},
    component: () => import("/opt/buildhome/repo/src/nuxt/pages/components/footer.vue")
  },
  {
    name: component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubagA3vLNoyhSaBOw3AIQcL_45wC7FI_OJ5gUmkpfjgrjRI
  }
]